import { useState } from 'react'
import { Card, CardHeader, CardTitle, CardDescription, CardContent, Textarea } from '@/components/ui'
import { Columns } from 'lucide-react'
import { diffWords } from 'diff'

export function TextDiffSideBySide() {
  const [text1, setText1] = useState('Hello world')
  const [text2, setText2] = useState('Hello there world')

  const diff = diffWords(text1, text2)

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500/20 to-cyan-500/20">
            <Columns className="h-6 w-6 text-blue-500" />
          </div>
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Text Diff (Side-by-Side)</h1>
            <p className="text-muted-foreground">Compare two texts side-by-side</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <Card className="glass">
          <CardHeader>
            <CardTitle>Text 1</CardTitle>
          </CardHeader>
          <CardContent>
            <Textarea
              value={text1}
              onChange={(e) => setText1(e.target.value)}
              className="h-96 font-mono"
            />
          </CardContent>
        </Card>
        <Card className="glass">
          <CardHeader>
            <CardTitle>Text 2</CardTitle>
          </CardHeader>
          <CardContent>
            <Textarea
              value={text2}
              onChange={(e) => setText2(e.target.value)}
              className="h-96 font-mono"
            />
          </CardContent>
        </Card>
      </div>

      <Card className="glass">
        <CardHeader>
          <CardTitle>Difference</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4 font-mono p-4 bg-muted/30 rounded-lg">
            <div>
              {diff.map((part, index) => {
                if (part.removed) {
                  return <span key={index} className="bg-red-500/20">{part.value}</span>
                }
                if (!part.added) {
                  return <span key={index}>{part.value}</span>
                }
                return null
              })}
            </div>
            <div>
              {diff.map((part, index) => {
                if (part.added) {
                  return <span key={index} className="bg-green-500/20">{part.value}</span>
                }
                if (!part.removed) {
                  return <span key={index}>{part.value}</span>
                }
                return null
              })}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
